import { videonystagmographyInstruction } from "@constants/instructionConstants";
import { virtualAssistantVideonystagmographyConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestUIConfiguration,
} from "types/testTypes";
import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
} from "../configurationHelperConstants";

export const availableVideonystagmographyTestConfigurationOptions: AvailablePreTestConfigurationOptions =
  {
    testTypes: {
      configurationFieldName: "testType",
      choices: [
        {
          validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.Videonystagmography],
          value: TestType.Videonystagmography,
        },
      ],
      isMandatory: true,
      validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.Videonystagmography],
    },
    eyeConfigurationOptions: { ...AVAILABLE_EYE_OPTIONS_BINOCULAR },
    languageOptions: null,
    virtualAssistantOptions: { ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS },
    testSpeedOptions: null,
  };

export const videonystagmographyTestConfiguration: TestConfiguration = {
  name: TestCategory.Videonystagmography,
  testType: TestType.Videonystagmography,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: true,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistantVideonystagmographyConfig,
  isPressToStartEnabled: true,
  extraData: null,
};

export const videonystagmographyUIConfiguration: TestUIConfiguration = {
  showProgressBar: false,
  instructions: videonystagmographyInstruction,
};
